<template>
  <VCard elevation="1" class="pa-0 pa-md-4 px-md-12 mb-5 grey--text text--darken-4">
    <VContainer>
      <AppPreloader v-if="loading" />
      <VAlert v-else-if="error.errorMessage" type="error">
        {{ company.fetchError }}
      </VAlert>
      <CandidateSupportForm v-else-if="candidate" :candidate-id="candidate.id" />
    </VContainer>
  </VCard>
</template>

<script>
import { mapState } from 'vuex';
import ApiMixin from '@/mixins/ApiMixin';
import AppPreloader from '@/components/AppPreloader.vue';
import CandidateSupportForm from '@/forms/CandidateSupportForm.vue';
import FetchCandidateByHashid from '@/mixins/FetchCandidateByHashid';

export default {
  name: 'CandidateSupport',
  components: { CandidateSupportForm, AppPreloader },
  mixins: [ApiMixin, FetchCandidateByHashid],
  metaInfo() {
    return {
      title: 'Huntica',
    };
  },
  props: {
    hashId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('candidate', {
      candidate: state => state.data?.candidate,
    }),
  },
};
</script>
